// VÁLASZTÓ-KÁRTYA (rádió-szemantikával) — a jegy-nyitó fiók- és szolgáltatás-választója.
//
// MIÉRT NEM legördülő: a partnernek jellemzően 1–5 fiókja és néhány szolgáltatása van, és a választás
// KONTEXTUST is hordoz (város/ügyfél, „Ön az elsődleges kapcsolattartó", „aktív szolgáltatás"). Egy `select`
// ezt a másodlagos sort nem tudja megjeleníteni — a terv ezért kártyás választót ad.
import { CheckIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';

export function PortalChoiceCard({
  selected,
  onSelect,
  title,
  subtitle,
  right,
}: {
  selected: boolean;
  onSelect: () => void;
  title: string;
  subtitle?: string | undefined;
  right?: ReactNode;
}): JSX.Element {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={onSelect}
      className={cn(
        'ease-atlas flex w-full items-center gap-2.5 rounded-[9px] border px-3.5 py-3 text-left transition-colors duration-150',
        selected ? 'border-brand bg-brand-soft' : 'border-border bg-card hover:bg-accent',
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'flex size-4 shrink-0 items-center justify-center rounded-full border-[1.5px] [&>svg]:size-2.5',
          selected ? 'bg-brand border-brand text-white' : 'border-border bg-card',
        )}
      >
        {selected && <CheckIcon strokeWidth={2.6} />}
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="truncate text-sm font-medium">{title}</span>
        {subtitle !== undefined && subtitle !== '' && (
          <Text variant="secondary" as="span" className="truncate text-[11px]">
            {subtitle}
          </Text>
        )}
      </span>
      {right}
    </button>
  );
}
